import React from 'react'
import Routes from './routes'

export const App: React.FC = () => {
  return (
    <Routes />
  )
}

export default App
